import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import NetworkBarGroupLink from '../NetworkBarGroupLink';
import Button from '../../../Button';
import GroupLinkLoader from '../GroupLinkLoader';
import FoldableGroup from '../FoldableGroup';
import { useNormalizedUserStream } from '../../../utils/hooks/useStream';
import { MobileContext } from '../../../Context/MobileContext';
import s from './FoldableGroupList.scss';
var GroupList = function (_a) {
    var streamId = _a.streamId, tabIndex = _a.tabIndex, isCollapsed = _a.isCollapsed, selectedItem = _a.selectedItem, selectedItemClassName = _a.selectedItemClassName, title = _a.title, icon = _a.icon, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useNormalizedUserStream(streamId), groups = _b.items, hasMore = _b.hasMore, isFetching = _b.isFetching, fetchNext = _b.fetchNext, errorMessage = _b.errorMessage;
    if (!isFetching && !groups.length && (!hasMore || errorMessage)) {
        return null;
    }
    return (React.createElement(FoldableGroup, { title: title, icon: icon, isCollapsed: isCollapsed, className: className },
        React.createElement("ul", null,
            groups.map(function (group, index) { return (React.createElement("li", { key: group.userId },
                React.createElement(NetworkBarGroupLink, { group: group, tabIndex: tabIndex, rank: index, isCollapsed: !isMobile && isCollapsed, isSelected: selectedItem === group.userId, className: classnames(selectedItem === group.userId && selectedItemClassName) }))); }),
            isFetching && (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed })),
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed })),
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed }))))),
        hasMore && !isFetching && !isCollapsed && (React.createElement(Button, { view: "b33", className: s['more-button'], onClick: fetchNext, tabIndex: tabIndex }, t('networkBar.groups.showMore')))));
};
GroupList.displayName = 'GroupList';
export default GroupList;
//# sourceMappingURL=FoldableGroupList.js.map